import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const VibeCard = ({ vibe, activeTab }) => {
  const { t } = useTranslation();
  // Convert UTC date and time to local
  let localDate = vibe.date;
  let localTime = vibe.time;
  
  if (vibe.date && vibe.time) {
    try {
      const utcDateTime = new Date(`${vibe.date}T${vibe.time}:00Z`);
      if (!isNaN(utcDateTime.getTime())) {
        localDate = utcDateTime.toLocaleDateString(undefined, {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
        let hour = utcDateTime.getHours();
        const minute = utcDateTime.getMinutes().toString().padStart(2, "0");
        const ampm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12;
        localTime = `${hour.toString().padStart(2, "0")}:${minute} ${ampm}`;
      }
    } catch (error) {
      // Keep original values as fallback
    }
  }

  const [acceptedMembers, setAcceptedMembers] = React.useState([]);
  const [declinedMembers, setDeclinedMembers] = React.useState([]);

  useEffect(() => {
    const accepted = Array.isArray(vibe.members)
      ? vibe.members.filter((m) => m.status === 1)
      : [];

    //   vibe.vibe_status === 3
    //   ? vibe.members
    //   : vibe.members.filter((m) => m.status === 0);

    const declined =
      vibe.vibe_status === 3
        ? Array.isArray(vibe.members)
          ? vibe.members
          : []
        : Array.isArray(vibe.members)
        ? vibe.members.filter((m) => m.status === 0)
        : [];

    if (vibe.id === 2274) {
    }
    setAcceptedMembers(accepted);
    setDeclinedMembers(declined);
  }, [vibe]);

  return (
    <Link
      key={vibe.id}
      to={`/vibe/${vibe.id}`}
      state={{ vibe, backTo: "/my-vibes", activeTab }}
      className="block"
      style={{ textDecoration: "none" }}
    >
      <div
        className="flex relative my-2 items-center bg-white dark:bg-[#0A0C1C] shadow-sm rounded-[8px] px-3 py-2 hover:shadow-md transition"
        style={{ minHeight: 64 }}
      >
        {/* Left: Date Badge */}
        <div
          className="relative flex flex-col items-center justify-center mr-3 rounded-[8px] bg-[#6c3fff]"
          style={{ padding: "8px 12px", minWidth: 48, minHeight: 48 }}
        >
          <span
            className="font-bold text-[12px] text-white"
            style={{ lineHeight: "1" }}
          >
            {dayjs(localDate).isValid() ? dayjs(localDate).format("MMM") : (localDate ? "..." : "")}
          </span>
          <span
            className="font-bold text-[20px] text-white mt-1"
            style={{ lineHeight: "1" }}
          >
            {dayjs(localDate).isValid() ? dayjs(localDate).format("D") : (localDate ? "?" : "")}
          </span>
        </div>
        {/* Center: Event Info */}
        <div className="flex-1 flex flex-col justify-center min-w-0">
          <div className="font-bold text-[15px] text-[#000] dark:text-dark-text truncate">
            {vibe.vibe_category?.name || vibe.title || "No Category"}
          </div>
          <div className="text-[13px] text-[#888] dark:text-dark-text-secondary mt-1 line-clamp-2 leading-tight">
            @{vibe.venue || vibe.location || "-"}
          </div>
        </div>
        {/* Right: Time Badge + Member Avatars + Pills */}
        <div
          className="flex flex-col items-end justify-between ml-2 h-full"
          style={{ minHeight: 48 }}
        >
          <div className="flex gap-2 mb-1">
            {vibe.vibe_status === 3 && (
              <span className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-lg">
                {t("cancelled", "Cancelled")}
              </span>
            )}
            <span
              className="bg-[#252739] text-white text-[12px] font-bold px-2 py-1 rounded-full"
              style={{ borderRadius: 6 }}
            >
              {localTime || vibe.time || "-"}
            </span>
          </div>
   <div className="flex items-center gap-0 sm:gap-4">
  {/* Accepted Avatars - Left Side */}
  <div className="flex -space-x-2.5 justify-end min-w-[60px] sm:min-w-[90px]">
    {acceptedMembers.slice(0, 3).map((m, idx) => (
      <span
        key={m.id}
        className="w-[22px] sm:w-[27px] h-[22px] sm:h-[27px] rounded-full border-2 border-white"
        style={{ zIndex: 10 - idx }}
      >
        <img
          src={m.user?.image || "/default-image.jpg"}
          alt={m.user?.full_name || m.user?.user_name || "User"}
          className="rounded-full w-full h-full object-cover"
        />
      </span>
    ))}

    {acceptedMembers.length > 3 && (
      <span
        className="w-[22px] sm:w-[27px] h-[22px] sm:h-[27px] rounded-full border-2 border-white flex items-center justify-center bg-[#17a2b8] text-white text-[10px] sm:text-[13px] font-bold"
        style={{ zIndex: 1 }}
      >
        +{acceptedMembers.length - 3}
      </span>
    )}
  </div>

  {/* Declined Avatars - Right Side (UNCHANGED) */}
  <div className="flex -space-x-4 declined-avatars justify-end sm:w-[90px] w-[60px]">
    {declinedMembers.slice(0, 3).map((m, idx, arr) => (
      <span
        key={m.id}
        className="w-[22px] sm:w-[27px] h-[22px] sm:h-[27px] rounded-full border-2 border-white"
        style={{ zIndex: idx + 5 }}
      >
        <img
          src={m.user?.image || "/default-image.jpg"}
          alt={m.user?.full_name || m.user?.user_name || "User"}
          className="rounded-full w-full h-full"
          style={{ objectFit: "cover" }}
        />
      </span>
    ))}
    {declinedMembers.length > 3 && (
      <span
        className="w-[22px] sm:w-[27px] h-[22px] sm:h-[27px] rounded-full border-2 border-white flex items-center justify-center bg-[#dc3545] text-white text-[13px] font-bold"
        style={{ zIndex: 20 }}
      >
        {`${declinedMembers.length - 3}`}
      </span>
    )}
  </div>
</div>
        </div>
      </div>
    </Link>
  );
};

export default VibeCard;
